import React from "react";
import { priceFormat } from "@/utils/common";
import { processDescText } from "../../utils";
import "./index.less";
import { GoodsItem } from "@/pages/charge-vip/types";

export interface SingleRowGoodsItemWithBuyProps {
  goodItem: GoodsItem;
  index: number;
  isDiscount: boolean;
  showCreditPrice: boolean;
}

export const SingleRowGoodsItemWithBuy: React.FC<
  SingleRowGoodsItemWithBuyProps
> = ({ goodItem, index, isDiscount, showCreditPrice }) => {
  const showCouponPrice =
    goodItem?.discountType === "COUPON_PRICE" &&
    goodItem?.discountBuyPrice !== null;
  return (
    <>
      <div
        className={`single-row-good-item-with-buy`}
        key={`good-${goodItem?.skuId}-${index}`}
      >
        <div className="good-price-wrap">
          <div className="good-price">
            <div className="big-heavy-text">¥{goodItem?.worth}</div>
          </div>
        </div>

        <div className="good-info-wrap">
          <div className="good-fill-wrap">
            <div className="good-title">{goodItem?.name || "--"}</div>
            <div className="good-extra">
              {processDescText(goodItem?.desc).map(
                (line: string, idx: number, array) => (
                  <React.Fragment key={idx}>
                    {line}
                    {idx < array.length - 1 && <br />}
                  </React.Fragment>
                ),
              )}
            </div>
          </div>

          <div className="good-buy-wrap">
            {showCouponPrice && (
              <div className="good-redpack">
                红包已减
                {priceFormat(goodItem?.salePrice - goodItem?.discountBuyPrice)}
                元
              </div>
            )}
            <div
              className={`good-buy-btn ${showCouponPrice ? "showCouponPrice" : ""}`}
            >
              <span className="good-price-content">
                <span className="big-heavy-text-unit">¥</span>
                <span className="big-heavy-text">
                  {priceFormat(
                    isDiscount
                      ? goodItem?.discountBuyPrice
                      : goodItem?.salePrice,
                  )}
                </span>
              </span>
              {isDiscount && (
                <span className="good-line-price">
                  ¥{priceFormat(goodItem?.salePrice)}
                </span>
              )}
            </div>
            <div className="good-points">
              {goodItem?.maxUseCreditAmount &&
                showCreditPrice &&
                `积分价：${goodItem?.maxUseCreditAmount}`}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
